import { render, staticRenderFns } from "./FooterText.vue?vue&type=template&id=f609d7e4&scoped=true&"
import script from "./FooterText.vue?vue&type=script&lang=js&"
export * from "./FooterText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f609d7e4",
  null
  
)

export default component.exports